import { render } from "./Digitizer.vue?vue&type=template&id=1d19098e"
import script from "./Digitizer.vue?vue&type=script&lang=js"
export * from "./Digitizer.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mark/Documents/vs_workspaces/sadc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__